import "babel-polyfill";
import "core-js/features/map";
import "core-js/features/set";
import "raf/polyfill";

import ErrorBoundary from "react-error-boundary";
import * as Sentry from "@sentry/browser";

import React from "react";
import ReactDOM from "react-dom";

import Cart from "./cart/cart.js";

import ContactUs from "./contactUs/contactUs.js";
import CustomLabelContainer from "./customLabel/container.js";
import ContactForm from "./contactUs/contactForm.js";

let cart = document.getElementById("cart-section");
let contactUs = document.getElementById("contact-us");
let customLabel = document.getElementById("custom-label-container");
let integrityAnnouncement = document.getElementById("integrity-announcement");

const initSentry = () => {
  if (Math.random() < 0.3) {
    Sentry.init({
      dsn: "https://224f8f5afc7a4d26ae8444944ead0495@sentry.io/1381360"
    });
  }
};

const cartErrorHandler = (error, componentStack) => {
  const msg = `Cart error at ${window.currentCountry()}: ` + error.message;
  Sentry.captureMessage(msg);
  console.log(msg);
};

const cartFallbackComponent = () => {
  return (
    <Cart
      disclaimer={disclaimerText()}
      saleOpts={{ active: false }}
      saleLimits={{ active: false, limits: [], fallback: true }}
      saleNotificationOpts={{}}
    />
  );
};

if (cart) {
  initSentry();

  ReactDOM.render(
    <ErrorBoundary
      onError={cartErrorHandler}
      FallbackComponent={cartFallbackComponent}
    >
      <Cart
        disclaimer={disclaimerText()}
        saleLimits={
          typeof SaleLimits != "undefined" && SaleLimits
            ? SaleLimits
            : { active: false, limits: [] }
        }
        saleOpts={
          typeof SaleOpts != "undefined" && SaleOpts
            ? SaleOpts
            : { active: false }
        }
        saleNotificationOpts={
          typeof SaleNotificationOpts === "undefined"
            ? null
            : SaleNotificationOpts
        }
      />
    </ErrorBoundary>,
    cart
  );
}

if (contactUs) {
  initSentry();

  ReactDOM.render(<ContactUs />, contactUs);
}

if (customLabel) {
  initSentry();

  ReactDOM.render(
    <CustomLabelContainer translations={window.personalizedTranslations} />,
    customLabel
  );
}

if (integrityAnnouncement) {
  initSentry();

  const IntegrityForm = () => {
    return (
      <ContactForm
        fields={[
          {
            ref: "choice",
            type: "dropdown",
            placeholder: "Choosing your claim",
            required: true
          },
          {
            ref: "name",
            type: "text",
            placeholder: "Name",
            required: true,
            autocomplete: "on"
          },
          {
            ref: "email",
            type: "email",
            placeholder: "Email",
            required: true,
            autocomplete: "on"
          },
          {
            ref: "orderNum",
            type: "text",
            placeholder: "Order/Sale Number",
            required: true
          },
          {
            ref: "storeType",
            type: "dropdown",
            placeholder: "Store type",
            required: true
          },
          {
            ref: "address1",
            type: "text",
            placeholder: "Address",
            required: true,
            autocomplete: "on"
          },
          {
            ref: "apt",
            type: "text",
            placeholder: "Apt, suite, etc.",
            required: false,
            autocomplete: "on"
          },
          {
            ref: "Country",
            type: "text",
            placeholder: "Country",
            required: true,
            autocomplete: "on"
          },
          {
            ref: "Tel",
            type: "text",
            placeholder: "Telephone number",
            required: true,
            autocomplete: "on"
          },
          {
            ref: "Postal/Zip",
            type: "text",
            placeholder: "Postal/Zip code",
            required: true,
            autocomplete: "on"
          },
          {
            ref: "terms",
            type: "checkbox",
            placeholder: "Terms agreement",
            required: true,
            label:
              "I acknowledge and accept that I must complete and submit a registration form to be eligible to receive a $20 eGift Card OR 20% off discount code. Once I complete and submit a registration form, I am only eligible for that one claim. Claims cannot be combined or changed. Limit one (1) claim per household. Valid online only at charmedaroma.com"
          }
        ]}
        allowUploads={false}
        requireUpload={false}
        isIntegrityEndpoint={true}
        groupName={"Appraisals"}
      >
        <option className="choice" value="">
          --- Choose your claim ---
        </option>
        <option className="choice" value="eGiftcardRequest">
          $20 eGift Card
        </option>
        <option className="choice" value="discountCodeRequest">
          20% Discount Code
        </option>

        <option className="storeType" value="">
          --- Choose the store type ---
        </option>
        <option className="storeType" value="retail">
          Store type: Retail
        </option>
        <option className="storeType" value="online">
          Store type: Online
        </option>
      </ContactForm>
    );
  };

  ReactDOM.render(<IntegrityForm />, integrityAnnouncement);
}
